export default __webpack_public_path__ + "2a6d2e9d929a6ac6f170d329bd65e50b.png";